import { GraphQLClient } from 'graphql-request';

const BASE_ENDPOINT = 'https://uapi.climate.com/app/graphql';
const headers = {
  'x-http-caller-id': process.env.npm_package_name,
  'x-http-caller-version': process.env.npm_package_version,
};

const graphQLClient = new GraphQLClient(BASE_ENDPOINT, {
  headers,
  credentials: 'include'
});

export const uapiFetcher = <T>(
  query: string,
  variables?: Record<string, unknown>,
  customHeaders?: Record<string, string>
) => graphQLClient.request<T>(query, variables, { ...headers, ...customHeaders });
